import MUserAvatar from './MUserAvatar.vue';

export { MUserAvatar };
export default MUserAvatar;
